import { css } from '@emotion/core'

export default {
  paginator: css`
    padding: 0 24px 24px;
  `,
  tableWrapper: css`
    width: 100%;
  `,
}
